import {
  jb_contact_css_default
} from "./chunk.72RELE7S.js";
import {
  ae
} from "./chunk.RIMVGMXQ.js";
import {
  setLink
} from "./chunk.LK5OUX7S.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  nlToBr
} from "./chunk.7QWDHXKG.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-contact/jb-contact.ts
var JbContact = class extends r {
  constructor() {
    super(...arguments);
    this.documents = [];
  }
  static _cleanPhoneNumber(input) {
    return input.trim().replace("(0)", "").replace(" ", "").replace(/[^\d#+*]/, "");
  }
  _renderDocuments() {
    return this.documents?.map((singleDocument) => {
      const anchor = document.createElement("a");
      if (singleDocument.documentLink.link) setLink(anchor, singleDocument.documentLink.link);
      anchor.innerText = (singleDocument.title ?? singleDocument.documentLink.text) + " | " + singleDocument.size;
      return ke`<p>${anchor}</p>`;
    });
  }
  static _renderLink(link) {
    const anchor = document.createElement("a");
    if (link.link) {
      setLink(anchor, link.link);
    }
    anchor.innerText = link.text ?? "";
    return ke`${anchor}`;
  }
  render() {
    return ke`
      <div class="wrapper">
        <article class="${Rt({ withimage: !!this.image })}">
          <div class="textcontent">
            <h4>${this.heading}</h4>
            ${this.address ? ke`<p>${ae(nlToBr(this.address))}</p>` : D}
            ${this.area ? ke`<p>${this.area}</p>` : D}
            ${this.position ? ke`<p>${this.position}</p>` : D}
            ${this.phoneNumber && this.phoneNumberLabel ? ke`<p>
                  <span>${this.phoneNumberLabel}</span>${JbContact._renderLink({
      text: this.phoneNumber,
      link: { href: "tel:" + JbContact._cleanPhoneNumber(this.phoneNumber) }
    })}
                </p>` : D}
            ${this.faxNumber && this.faxNumberLabel ? ke`<p><span>${this.faxNumberLabel}</span>${this.faxNumber}</p>` : D}
            ${this.documents && this.documents.length > 0 ? ke`${this._renderDocuments()}` : D}
            ${this.additionalText ? ke`<p>${ae(nlToBr(this.additionalText))}</p>` : D}
            ${this.link || this.contactLink ? ke`<p class="links">
                  ${this.contactLink ? ke`<p class="maillink">${JbContact._renderLink(this.contactLink)}</p>` : D}
                  ${this.link ? ke`<p class="maillink">${JbContact._renderLink(this.link)}</p>` : D}
                </p>` : D}
          </div>
          ${this.image && ke`<jb-picture
            .imgData=${this.image.imgData}
            ?lazy=${this.image.lazy}
          ></jb-picture>`}
        </article>
      </div>
    `;
  }
};
JbContact.styles = jb_contact_css_default;
__decorateClass([
  n()
], JbContact.prototype, "additionalText", 2);
__decorateClass([
  n()
], JbContact.prototype, "address", 2);
__decorateClass([
  n()
], JbContact.prototype, "area", 2);
__decorateClass([
  n({ type: Object })
], JbContact.prototype, "contactLink", 2);
__decorateClass([
  n({ type: Array })
], JbContact.prototype, "documents", 2);
__decorateClass([
  n()
], JbContact.prototype, "faxNumber", 2);
__decorateClass([
  n()
], JbContact.prototype, "faxNumberLabel", 2);
__decorateClass([
  n()
], JbContact.prototype, "heading", 2);
__decorateClass([
  n({ type: Object })
], JbContact.prototype, "image", 2);
__decorateClass([
  n({ type: Object })
], JbContact.prototype, "link", 2);
__decorateClass([
  n()
], JbContact.prototype, "phoneNumber", 2);
__decorateClass([
  n()
], JbContact.prototype, "phoneNumberLabel", 2);
__decorateClass([
  n()
], JbContact.prototype, "position", 2);
JbContact = __decorateClass([
  customElement("jb-contact")
], JbContact);

export {
  JbContact
};
